import { render } from "./footerView.vue?vue&type=template&id=159d79cb&scoped=true"
import script from "./footerView.vue?vue&type=script&lang=js"
export * from "./footerView.vue?vue&type=script&lang=js"

import "./footerView.vue?vue&type=style&index=0&id=159d79cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159d79cb"]])

export default __exports__